import { Box, Footer, Grid, Header } from 'grommet';
import { ReactNode } from 'react';
import { ImpersonationBanner } from '../ui';
import { FooterNav } from '../nav/FooterNav';
import { HeaderNav } from '../nav/HeaderNav';

export const Layout = ({ children }: { children: ReactNode; showSidebar?: boolean }) => {
  return (
    <Grid
      height={{ min: '100vh', max: '100vh' }}
      rows={['auto', 'auto', 'flex', 'auto']}
      columns={['auto', 'flex']}
      areas={[
        { name: 'header', start: [0, 0], end: [1, 0] },
        { name: 'banner', start: [0, 1], end: [1, 1] },
        { name: 'main', start: [0, 2], end: [1, 2] },
        { name: 'footer', start: [0, 3], end: [1, 3] },
      ]}
      gap="none"
    >
      <Header gridArea="header">
        <HeaderNav />
      </Header>
      <Box gridArea="banner">
        <ImpersonationBanner />
      </Box>
      {/* Bottom padding keeps the floating chat launcher (fixed, bottom-right) from sitting on
          top of the last row of scrolled content — see ChatWidget.tsx. */}
      <Box gridArea="main" background="background-back" overflow="auto" pad={{ bottom: '110px' }}>
        {children}
      </Box>
      <Footer gridArea="footer">
        <FooterNav />
      </Footer>
    </Grid>
  );
};
